interface CreateAgentRoomResponse {
  status: string
  room_url: string
  token: string
  room_name: string
  agent_id: string
}

interface CreateAgentRoomRequest {
  agent_id: string
}

interface GetAgentResponse {
  image_url: string
  first_video_url: string
  max_conv_dur: number
  sufficient_balance: boolean
}

const PIPECAT_BASE_URL = import.meta.env.VITE_PIPECAT_BASE_URL || ''
const WEB_APP_BASE_URL = import.meta.env.VITE_WEB_APP_BASE_URL || ''

export async function createAgentRoom(
  agentId: string
): Promise<CreateAgentRoomResponse> {  
  if (import.meta.env.VITE_TEST_ROOM) {
    const testRoomUrl = import.meta.env.VITE_TEST_ROOM || ''
    return {
      status: 'success',
      room_url: testRoomUrl,
      token: 'test',
      room_name: 'test',
      agent_id: agentId,
    }
  }

  const response = await fetch(`${PIPECAT_BASE_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ agent_id: agentId } as CreateAgentRoomRequest),
  })

  if (!response.ok) {
    throw new Error(`Failed to create agent room: ${response.statusText}`)
  }

  const data = await response.json()
  return data as CreateAgentRoomResponse
}

export async function getAgent(
  agentId: string
): Promise<GetAgentResponse> {
  const response = await fetch(`${WEB_APP_BASE_URL}/agents/${agentId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to get agent: ${response.statusText}`)
  }

  const data = await response.json()
  return data as GetAgentResponse
}
